/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unmuteThread.defs'
export { main as default } from './unmuteThread.defs'
